(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-oos-lead-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    function closestSection(el) {
      return el.closest(".shopify-section") || document;
    }

    function setOos(root, isOos) {
      const section = closestSection(root);
      section.querySelectorAll("[data-oos-lead]").forEach((node) => {
        node.classList.toggle("is-oos", isOos);
        const trigger = node.querySelector("[data-oos-lead-open]");
        if (trigger) {
          trigger.hidden = !isOos;
          trigger.classList.toggle("is-hidden", !isOos);
        }
      });
      const add = section.querySelector(".product-add-to-cart");
      const sticky = section.querySelector(".js-sticky-add-to-cart");
      const apex = section.querySelector("[data-apex-buy]");
      if (add) add.classList.toggle("is-oos", isOos);
      if (sticky) sticky.classList.toggle("is-oos", isOos);
      if (apex) apex.classList.toggle("is-oos", isOos);
    }

    function bindDialog(dialog) {
      if (!dialog || dialog.dataset.oosBound === "true") return;
      dialog.dataset.oosBound = "true";
      dialog.querySelectorAll("[data-oos-lead-close]").forEach((btn) => {
        btn.addEventListener("click", () => dialog.close());
      });
      dialog.addEventListener("click", (event) => {
        if (event.target === dialog) dialog.close();
      });
    }

    function openDialog(id) {
      const dialog = document.getElementById(id);
      if (!dialog || typeof dialog.showModal !== "function") return;
      bindDialog(dialog);
      if (!dialog.open) dialog.showModal();
    }

    function variantIsOos(detail) {
      const variant = detail && (detail.variant || detail.currentVariant);
      return Boolean(variant) && variant.available === false;
    }

    // Buy it now shows for InStock only. The map comes from variant-availability.
    function setBuyNow(root, detail) {
      const variant = detail && (detail.variant || detail.currentVariant);
      const section = closestSection(root);
      const map = section.querySelector("[data-variant-stock]");
      const wrap = section.querySelector("[data-buy-now]");
      if (!variant || !map || !wrap) return;
      try {
        wrap.hidden = JSON.parse(map.textContent)[variant.id] !== "InStock";
      } catch (e) {}
    }

    function listenForVariants(root) {
      const bus = window.themeCore && window.themeCore.EventBus;
      const sectionId = root.getAttribute("data-oos-section");
      if (!bus || !sectionId || root.dataset.oosListening === "true") return Boolean(bus);
      root.dataset.oosListening = "true";

      const onVariant = (detail) => {
        setOos(root, variantIsOos(detail));
        setBuyNow(root, detail);
      };
      bus.listen("pdp:section-" + sectionId + ":change-variant", onVariant);
      closestSection(root).querySelectorAll("[data-js-product-form]").forEach((form) => {
        const formId = form.getAttribute("id");
        if (formId) bus.listen("form:" + formId + ":change-variant", onVariant);
      });
      return true;
    }

    function init() {
      document.querySelectorAll("[data-oos-lead]").forEach((root) => {
        setOos(root, root.getAttribute("data-oos-start") === "true");
        bindDialog(root.querySelector("dialog"));
        if (!listenForVariants(root)) {
          window.addEventListener("load", () => listenForVariants(root), { once: true });
        }
      });
    }

    document.addEventListener("click", (event) => {
      const btn = event.target.closest("[data-oos-lead-open]");
      if (!btn) return;
      event.preventDefault();
      openDialog(btn.getAttribute("data-oos-lead-open"));
    });

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
